<template>
  <a href="javascript:;" class="'hovers" :show_report_50bang="pageAdInfo.show_report_50bang" :id="pageAdInfo.divId" @mousedown="getClktkData(0)" @mouseup="getClktkData(1)" @click="clickReport($event, pageAdInfo.url)" target="_blank" curType="right" style="width: 100%;display: block;width: 243px;">
    <div class="img">
      <div class="ad" target="_blank"><img :src="pageAdInfo.miniimg[0].src"></div>
    </div>
    <div class="rt-news">
      <div :href="pageAdInfo.url" target="_blank" class="news-title" v-text="pageAdInfo.topic"></div>
    </div>
  </a>
</template>
<script>
import ad from '../../api/ad';
import util from '../../api/util';
import stats from '../../api/statistics';
import ad360 from '../../api/ad/ad_360';

export default {
  name: 'NewsTplAd360Right',
  props: [
    'newsAdInfo', 'compName', 'tag', 'pageType'
  ],
  data () {
    return {
      pageAdInfo: {
        url: '',
        divId: '',
        miniimg: [{src: ''}],
        topic: '',
      },
      iframeRect: {
        stop: 0,
        wheight: 0
      }
    }
  },
  mounted () {
    this.pageAdInfo = this.newsAdInfo;
    this.clktkData = {};
    this.$bus.$on('showRight', (data) => {
      this.iframeRect = data.rect;
      this.showReport();
    });
    this.$bus.$on('showReport', (data) => {
      this.iframeRect = data.rect;
      this.showReport();
    });
  },
  methods : {
    getClktkData (type) {
      if (type) {
        // 鼠标抬起时间戳
        this.clktkData.__EVENT_TIME_END__ = Date.now();
      } else {
        // 鼠标按下时间戳
        this.clktkData.__EVENT_TIME_START__ = Date.now();
      }
    },
    /**
     * 发送展现统计
     */
    showReport () {
      if (this.pageAdInfo['show_report_50bang'] !== 'reported' && util.isElementInViewport(this.pageAdInfo.divId, this.iframeRect, this.pageType)) {
        stats.ajax99(this.pageAdInfo.show_report_50bang);
        ad360.showReport(this.pageAdInfo.imptk);
        this.pageAdInfo['show_report_50bang'] = 'reported';
      }
    },
    /**
     * 点击统计
     */
    clickReport (event, directUrl) {
      var _this = this;
      if (util.isElementInViewport(this.pageAdInfo.divId, this.iframeRect, this.pageType) && this.pageAdInfo.hasOwnProperty('click_report_50bang')) {
        stats.ajax99(this.pageAdInfo.click_report_50bang);
        var clktkTpl = this.pageAdInfo.clktk;
        var clktkUrl = clktkTpl.concat();
        clktkUrl = _this.macroExchange(clktkUrl, this.clktkData, event);
        ad360.showReport(clktkUrl);
      }
      // 跳转
      window.open(_this.getMacroInfo(directUrl, this.clktkData, event));
    },
    /**
     * 宏替换遍历
     */
    macroExchange (arrReportUrls, clktkData, event) {
      var _this = this;
      if (arrReportUrls.length > 0) {
        arrReportUrls.forEach(function (reportUrl, index) {
          arrReportUrls[index] = _this.getMacroInfo(reportUrl, clktkData, event);
        })
      }
      return arrReportUrls;
    },
    /**
     * 宏替换
     */
    getMacroInfo (directUrl, clktkData, event) {
      directUrl = directUrl.replace('__EVENT_TIME_START__', clktkData.__EVENT_TIME_START__);
      directUrl = directUrl.replace('__EVENT_TIME_END__', clktkData.__EVENT_TIME_END__);
      directUrl = directUrl.replace('__OFFSET_X__', event.offsetX);
      directUrl = directUrl.replace('__OFFSET_Y__', event.offsetY);
      return directUrl;
    }
  }
}
</script>
